enum MaterialPatrimonyAdministrativeInstanceTypeEnum {
    MUNICIPAL = 'MUNICIPAL', //Municipal
    STATE = 'STATE', //Estadual
    FEDERAL = 'FEDERAL', //Federal
    MERCOSUR = 'MERCOSUR', //Mercosul
    WORLD = 'WORLD', //Mundial
}

export default MaterialPatrimonyAdministrativeInstanceTypeEnum;
